import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

// show=0 open
// show<> 0 close

function ModalVwFrame(
  showBtn,
  showThis,
  showModal,
  btnLbl,
  title,
  mdlChild,
  isFullScreen
) {
  const [show, setShow] = useState(showThis);

  useEffect(() => {
    setShow(showThis);
  }, [showThis]);

  const handleClose = () => {
    setShow(false);
    showModal(false);
  };

  const handleShow = () => {
    setShow(true);
    showModal(true);
  };

  return (
    <>
      {showBtn ? (
        <Button
          onClick={handleShow}
          style={{ backgroundColor: "lightslategray" }}
        >
          {btnLbl}
        </Button>
      ) : (
        <></>
      )}

      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Header
          closeButton
          style={{ backgroundColor: title === "HomeCare" ? "orange" : "" }}
        >
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{mdlChild}</Modal.Body>
      </Modal>
    </>
  );
}

export default ModalVwFrame;
